/* Coordinates the Shopify product-description sample player with the existing preview contract. */
(() => {
  'use strict';
  if (window.edmtSampleBridge) return;
  const bridge = window.edmtSampleBridge = { bound: false };
  const labels = document.currentScript?.dataset || {};
  const source = 'cyberpunk-samples';
  const init = () => {
    if (bridge.bound) return;
    if (!document.getElementById('waveformContainer') || typeof wavesurfer === 'undefined' || !wavesurfer || typeof stopPreviewPlayback !== 'function') return;
    bridge.bound = true;
    const stop = event => {
      if (event?.detail?.source !== source) stopPreviewPlayback();
    };
    const claim = () => {
      document.dispatchEvent(new CustomEvent('edmt:preview-start', { detail: { source } }));
      document.dispatchEvent(new CustomEvent('edmt:card-preview-start', { detail: { source } }));
    };
    document.addEventListener('edmt:preview-start', stop);
    document.addEventListener('edmt:card-preview-start', stop);
    document.addEventListener('play', event => {
      if (event.target instanceof HTMLMediaElement && event.target !== wavesurfer.getMediaElement?.() && !event.target.muted) stopPreviewPlayback();
    }, true);
    wavesurfer.on('play', () => {
      if (!isAutoplaying) { wavesurfer.pause(); return; }
      claim();
    });
    document.getElementById('playPause').addEventListener('click', () => { if (!isAutoplaying) claim(); }, true);
    for (const id of ['prevSample','nextSample']) {
      const button = document.getElementById(id);
      if (!button) continue;
      button.setAttribute('aria-label', id === 'prevSample' ? labels.edmtPrevLabel : labels.edmtNextLabel);
      button.addEventListener('click', () => { if (isAutoplaying) claim(); }, true);
    }
    document.querySelectorAll('.sample-category-btn').forEach(button => button.addEventListener('click', () => { if (isAutoplaying) claim(); }, true));
    window.addEventListener('pagehide', () => stopPreviewPlayback());
  };
  const schedule = () => requestAnimationFrame(init);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('page:loaded', schedule);
  if (document.readyState !== 'loading') schedule();
})();
